import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { queryKeys } from "#shared/queryKeys/queryKeys";

import { fetchWeldLength } from "./fetchWeldLength.api";

export const weldLengthQuery = (id: string | undefined) => ({
  queryKey: queryKeys.parts.weldLength(id),
  queryFn: () => fetchWeldLength(id),
  staleTime: STALE_TIME,
});
